var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"elevator"},[_c('div',{staticClass:"elevator__top"},[_c('div',{staticClass:"elevator__dial",on:{"click":_vm.clickDial}}),_vm._v(" "),_c('div',{staticClass:"elevator__arrow"})]),_vm._v(" "),_c('div',{staticClass:"elevator__door-left"}),_vm._v(" "),_c('div',{staticClass:"elevator__door-right"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1afb7fbb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Elevator.vue
// module id = null
// module chunks = 